@import "../../../../styles/colors.less";

.root :global {
  #preview *::selection {
    background: @blue;
    color: @white;
  }
}
